module.exports = __webpack_public_path__ + "assets/68d6d3daf81628ca098805b19072d24a.png";